<div class="modal fade" [id]="modalId" tabindex="1" [attr.data-keyboard]="viewMode ? 'true' : null"
[attr.data-backdrop]="viewMode ? null : 'static'" aria-hidden="true" role="dialog"
    style="width: 70vw !important; margin-left: 15vw;">
    <div class="modal-dialog" style="max-width: 100% !important;">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">{{language.instructions}}</h4>
                <ng-container *ngIf="viewMode">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </ng-container>
            </div>
            <div class="modal-body p-0">
                <div class="card p-2">
                    <div class="card-body text-center p-2" style="color: #74bbf7;">
                        <div class="accordion" [id]="'instructionaccordion' + examId">

                            <!-- WebTest Instructions -->
                            <div *ngIf="webtestHTML" class="card">
                                <div class="card-header" [id]="'webtest' + examId" data-toggle="collapse"
                                    [attr.data-target]="getHTMLIDRef('webtest', examId)"
                                    [attr.aria-expanded]="webtestHTML ? 'true' : 'false'"
                                    [attr.aria-controls]="getHTMLIDRef('webtest', examId)">
                                    <h6 class="mb-0">
                                        <span>WEBTEST {{language.webtestInstruction}}</span>
                                    </h6>
                                </div>
                                <div [id]="'collapsewebtest' + examId" class="collapse"
                                    [ngClass]="{'show': webtestHTML, 'hide': !webtestHTML}"
                                    [attr.aria-labelledby]="getHTMLIDAria('webtest', examId)"
                                    [attr.data-parent]="getHTMLIDParent(examId)">
                                    <div class="card-body instruct" [innerHTML]="this.webtestHTML">
                                    </div>
                                </div>
                            </div>

                            <!-- Company Instructions -->
                            <div *ngIf="companyHTML" class="card">
                                <div class="card-header" [id]="'company' + examId" data-toggle="collapse"
                                    [attr.data-target]="getHTMLIDRef('company', examId)"
                                    [attr.aria-expanded]="!webtestHTML && companyHTML ? 'true' : 'false'"
                                    [attr.aria-controls]="getHTMLIDRef('company', examId)">
                                    <h6 class="mb-0">
                                        <span>{{company | uppercase}} {{language.instructions | uppercase}}</span>
                                    </h6>
                                </div>
                                <div [id]="'collapsecompany' + examId" class="collapse"
                                    [ngClass]="{'show': !webtestHTML && companyHTML, 'hide': !(!webtestHTML && companyHTML)}"
                                    [attr.aria-labelledby]="getHTMLIDAria('company', examId)"
                                    [attr.data-parent]="getHTMLIDParent(examId)">
                                    <div class="card-body instruct" [innerHTML]="this.companyHTML">
                                    </div>
                                </div>
                            </div>

                            <!-- Exam Instructions -->
                            <div *ngIf="examHTML" class="card">
                                <div class="card-header" [id]="'exam' + examId" data-toggle="collapse"
                                    [attr.data-target]="getHTMLIDRef('exam', examId)"
                                    [attr.aria-expanded]="!webtestHTML && !companyHTML && examHTML ? 'true' : 'false'"
                                    [attr.aria-controls]="getHTMLIDRef('exam', examId)">
                                    <h6 class="mb-0">
                                        <span>{{examName | uppercase}} {{language.instructions | uppercase}}</span>
                                    </h6>
                                </div>
                                <div [id]="'collapseexam' + examId" class="collapse"
                                    [ngClass]="{'show': !webtestHTML && !companyHTML && examHTML, 'hide': !(!webtestHTML && !companyHTML && examHTML)}"
                                    [attr.aria-labelledby]="getHTMLIDAria('exam', examId)"
                                    [attr.data-parent]="getHTMLIDParent(examId)">
                                    <div class="card-body instruct" [innerHTML]="this.examHTML">
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <ng-container *ngIf="!viewMode">
                <div class="row m-2">
                    <div class="col-md-4"></div>
                    <div class="modal-footer col-md-4 p-0">
                        <span>
                            <input class="mr-2" type="checkbox" id="confirmation"
                                (change)="confirmationchecked($event)">
                            <span><b>{{language.agreeToInstructions}}</b></span>
                        </span>
                        <input [disabled]="!confirmed" class="form-control btn btn-success" type="button"
                            data-dismiss="modal" (click)="gotoexam(true)" [value]="language.startExam" />
                        <input class="form-control btn btn-danger" type="button" id="clear-options"
                            (click)="resumeinterval()" data-dismiss="modal" [value]="language.cancel" />
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</div>